import { useEffect, useState } from "react";
import "../styles/challenge-theme.css";
import moment from "moment";
import Button from "../../../../ui/atoms/buttons/Button";
import NotFound from "../../../../ui/organisms/not-found/404";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  capitalizeAll,
  isEmpty,
  slugify,
  truncateValue,
} from "../../../../core/utils/helpers";
import { onGetChallengeThemeCategoriesWithPagination } from "../../services/challengeTheme";
import StatusComponent from "../../../../ui/atoms/status/StatusComponent";
import { challengeSlice } from "../../../../app/store/slices/challengeSlice";
import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";

const ChallengeThemeCategory = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [challengeThemeCategories, setChallengeThemeCategories] = useState([]);
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [selectedRows, setSelectedRows] = useState([]);
  const [checkedRows, setCheckedRows] = useState([]);
  const [checkedChallengeThemeCategories, setCheckedChallengeThemeCategories] =
    useState([]);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;

    const _localData = {
      rows_per_page: rowsPerPage,
      current_page: currentPage,
    };

    onGetChallengeThemeCategoriesWithPagination(
      axiosPrivate,
      _localData,
      signal,
    ).then((response) => {
      const _data = response?.data;
      setChallengeThemeCategories(_data);
    });

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [rowsPerPage, currentPage]);

  const onHandleSelectRow = (id) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id],
    );
    setCheckedRows((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id],
    );
  };

  const onHandleSelectCurrentTeamMember = (challenge_theme_categories) => {
    setCheckedChallengeThemeCategories((prevSelected) =>
      prevSelected.some((item) => item.id === challenge_theme_categories.id)
        ? prevSelected.filter(
            (item) => item.id !== challenge_theme_categories.id,
          )
        : [...prevSelected, challenge_theme_categories],
    );
  };

  const onHandleSelectAll = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      const allChallenge_theme_categoriesIds =
        challengeThemeCategories?.result?.map((item) => item.id);
      setSelectedRows(allChallenge_theme_categoriesIds);
      setCheckedRows(allChallenge_theme_categoriesIds);
    } else {
      setSelectedRows([]);
      setCheckedRows([]);
    }
  };
  const isAllSelected =
    selectedRows?.length === challengeThemeCategories?.result?.length;

  return (
    <div className="challenge-themes">
      <div className="challenge-theme-head">
        <h1>Challenge Theme Categories Management</h1>
        <div className="w-full d-flex justify-space-between">
          <Button
            type={"button"}
            preferedStyle={"default"}
            title={"➕ Create new Challenge Theme Category"}
            action={() => navigate("/admin/challenge/themes/categories/create")}
          />
          {selectedRows.length > 0 && (
            <div className="c-t-actions fade-in">
              {selectedRows.length === 1 && (
                <>
                  <Button
                    type={"button"}
                    preferedStyle={"default"}
                    title={"👁️ Voir details"}
                    action={() => {
                      dispatch(
                        challengeSlice.actions.onCurrentChallengeThemeCategory(
                          checkedChallengeThemeCategories[0],
                        ),
                      );
                      // navigate(`/admin/users/details?userId=${selectedRows[0]}`);
                    }}
                  />
                  <Button
                    type={"button"}
                    preferedStyle={"default"}
                    title={"🔄 Update infos"}
                    action={() => navigate("/admin/users/update")}
                  />
                </>
              )}
              <Button
                type={"button"}
                preferedStyle={"default"}
                title={"🔐 Activate or Desactivate account"}
                action={""}
              />
            </div>
          )}
        </div>
      </div>
      <div className="challenge-theme-body">
        {isEmpty(challengeThemeCategories?.result) ? (
          <NotFound
            type={"data"}
            title={"No Challenge Theme Category found!"}
            text={"No Challenge Theme Category available yet."}
            isBoutton={false}
          />
        ) : (
          <>
            <div className="table">
              <table>
                <thead>
                  <tr>
                    <th className="col-05 text-align-center">
                      <input
                        type="checkbox"
                        checked={isAllSelected}
                        onChange={onHandleSelectAll}
                      />
                    </th>
                    <th className="col-20 text-align-left">Date of creation</th>
                    <th className="col-35 text-align-left">
                      Category's Titles
                    </th>
                    <th className="col-15 text-align-left">
                      Status(Visibility)
                    </th>
                    <th className="col-15 text-align-left">Status(Deletion)</th>
                    <th className="col-10 text-align-left">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {challengeThemeCategories?.result?.map((item, idx) => {
                    return (
                      <tr
                        key={idx}
                        className={
                          checkedRows.includes(item.id) ? "row-checked" : ""
                        }
                      >
                        <td className="col-05 text-align-center">
                          <input
                            type="checkbox"
                            checked={selectedRows.includes(item.id)}
                            onChange={() => {
                              onHandleSelectCurrentTeamMember(item);
                              onHandleSelectRow(item.id);
                            }}
                          />
                        </td>
                        <td className="col-20 text-align-left">
                          {moment(item?.created_at).format("LLLL")}
                        </td>
                        <td className="col-35 text-align-left">
                          <span className="span-names">
                            {capitalizeAll(item?.title_en)} /{" "}
                            {capitalizeAll(item?.title_fr)}
                          </span>
                        </td>
                        <td className="col-15 text-align-left">
                          <StatusComponent
                            type={item?.is_activated ? "success" : "error"}
                            title={
                              item?.is_activated ? "Released" : "UnReleased"
                            }
                          />
                        </td>
                        <td className="col-15 text-align-left">
                          <StatusComponent
                            type={item?.is_deleted ? "error" : "success"}
                            title={item?.is_deleted ? "Archived" : "UnArchived"}
                          />
                        </td>
                        <td className="col-10 text-align-left">
                          <Button
                            type={"button"}
                            preferedStyle={"default"}
                            title={`more about ${truncateValue(
                              capitalizeAll(item?.title_en),
                              7,
                            )}`}
                            action={() => {
                              dispatch(
                                challengeSlice.actions.onCurrentChallengeThemeCategory(
                                  item,
                                ),
                              );
                              navigate(
                                `/admin/challenge/themes/get/${slugify(item?.title_en)}/${slugify(item?.title_fr)}`,
                              );
                            }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="pagination">
              <div className="p-wrapper">
                <button
                  className={
                    challengeThemeCategories?.result_complements
                      ?.current_page === 1
                      ? "button is-inactive"
                      : "button is-active"
                  }
                  onClick={() => {
                    setCurrentPage((prev) => (prev > 1 ? prev - 1 : 1));
                    setSelectedRows([]);
                  }}
                  disabled={
                    challengeThemeCategories?.result_complements
                      ?.current_page === 1
                  }
                >
                  Previous
                </button>
                <span>
                  Page {currentPage} of{" "}
                  {challengeThemeCategories?.result_complements?.total_pages}{" "}
                  pages.
                </span>
                <button
                  className={
                    challengeThemeCategories?.result_complements
                      ?.current_page ===
                    challengeThemeCategories?.result_complements?.total_pages
                      ? "button is-inactive"
                      : "button is-active"
                  }
                  onClick={() => {
                    setCurrentPage((prev) =>
                      prev <=
                      challengeThemeCategories?.result_complements?.total_pages
                        ? prev + 1
                        : prev,
                    );
                    setSelectedRows([]);
                  }}
                  disabled={
                    challengeThemeCategories?.result_complements
                      ?.current_page ===
                    challengeThemeCategories?.result_complements?.total_pages
                  }
                >
                  Next
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ChallengeThemeCategory;
